<template>
  <div class="pb-3">
    <va-card :title="$t(`sendNotification.title`)">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(send)">
          <div class="row">
            <div class="flex md12">
              <ValidationProvider rules="required" name="Titulo da Mensagem" v-slot="{ errors }">
                <va-input
                  v-model="video.title"
                  :label="$t('sendNotification.forms.titleLabel')"
                  :placeholder="$t('sendNotification.forms.titlePlaceholder')"
                  :success="errors.length == 0 && video.title.length > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <ValidationProvider rules="required" name="Corpo da Mensagem" v-slot="{ errors }">
                <va-input
                  v-model="video.subtitle"
                  :label="$t('sendNotification.forms.bodyLabel')"
                  :placeholder="$t('sendNotification.forms.bodyPlaceholder')"
                  :success="errors.length == 0 && video.subtitle.length > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <div v-if="imageUrl" class="form-group mb-2">
                <label>{{ $t('sendNotification.forms.imageLabel') }}</label>
                <div class="mt-1">
                  <img
                    :src="imageUrl"
                    alt="Preview da Thumbnail"
                    style="max-width: 100%; max-height: 180px; border-radius: 6px; object-fit: cover; display: block; border: 1px solid #e0e0e0;"
                  />
                </div>
              </div>
              <div v-if='video.file.length > 0' class="form-group mt-3">
                <video style="height: 30vh; max-width: 100%;" controls>
                  <source :src="$store.getters['environment/cdn'] + '/video/' + video.file">
                </video>
              </div>
            </div>
            <div class="d-flex mt-1">
              <va-button
                type="submit"
                :disabled="buttonSubmitDisabled"
                color="success"
                class="my-0">
                {{ textSubmit }}
              </va-button>
              <va-button
                type="button"
                class="my-0"
                color="danger"
                @click="cancel">
                {{ $t("forms.cancel") }}
              </va-button>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </va-card>
  </div>
</template>

<script>
export default {
  name: 'sendNotification',
  props: {
    sendData: {
      required: true,
    },
  },
  data () {
    return {
      video: {
        id: '',
        title: '',
        subtitle: '',
        file: '',
        thumbnail: '',
      },
      buttonSubmitDisabled: false,
      textSubmit: this.$t('forms.send'),
    }
  },
  computed: {
    imageUrl () {
      if (!this.video || !this.video.thumbnail) return ''
      if (this.video.thumbnail.includes('http')) {
        return this.video.thumbnail
      }
      const cdn = (this.$store.getters['environment/cdn'] || 'https://cdn.s1live.com').replace(/\/+$/, '')
      return `${cdn}/thumbnail-video/${this.video.thumbnail}`
    },
  },
  mounted () {
    this.video.id = ''
    this.video.title = ''
    this.video.subtitle = ''
    this.video.file = ''
    this.video.thumbnail = ''
    if (this.sendData !== null) {
      this.video_get(this.sendData)
    }
  },
  methods: {
    cancel () {
      this.$emit('close', false)
    },
    video_get (data) {
      Object.keys(data).forEach((value, _) => {
        this.video[value] = data[value]
      })
    },
    send () {
      this.buttonSubmitDisabled = true
      this.textSubmit = this.$t('forms.sending')
      const self = this
      this.$axios.post(
        '/api/messaging/video',
        {
          title: this.video.title,
          body: this.video.subtitle,
          id: this.video.id,
          image: this.video.thumbnail,
        },
      ).then(response => {
        self.buttonSubmitDisabled = false
        self.textSubmit = self.$t('forms.send')
        self.$emit('close', false)
        self.showToast(
          self.$t('toasts.successSend'),
          {
            icon: 'fa-check',
            position: 'top-right',
            duration: 1000,
            fullWidth: false,
          },
        )
      })
        .catch(e => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.send')
          self.showToast(
            self.$t('toasts.errorSend'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
  },
}
</script>
